/**
** JAVASCRIPTS
** Name: Form Validation
********************************************************************************/

document.addEventListener("DOMContentLoaded", () => {

  const emailInputs = document.querySelectorAll('input[type="email"]');

  if (emailInputs.length > 0) {
    emailInputs.forEach((input) => {
      input.addEventListener("input", () => {
        input.setCustomValidity("");
        input.checkValidity();
      });

      input.addEventListener("invalid", () => {
        if (input.value === "") {
          input.setCustomValidity("");
        } else {
          input.setCustomValidity(
            "Veuillez saisir une adresse email valide. Par exemple, nom@domaine.fr"
          );
        }
      });
    });
  }

  const formsRecaptcha = [];
  const submitsRecaptcha = document.querySelectorAll(".g-recaptcha[data-form-id]");

  const fixedEl = document.querySelector(".js-fixed");

  function loadRecaptchaScript() {
    if (window.grecaptcha) return;

    if (document.querySelector('script[src*="google.com/recaptcha/api.js"]')) return;

    const script = document.createElement("script");
    script.src = "https://www.google.com/recaptcha/api.js?hl=fr";
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);
  }

  function handleFormFocusIn() {
    loadRecaptchaScript();
    formsRecaptcha.forEach((form) => {
      form.removeEventListener("focusin", handleFormFocusIn);
    });
    if (fixedEl) {
      fixedEl.classList.add("o-fixed--recaptcha");
    }
  }

  if (submitsRecaptcha.length > 0) {
    submitsRecaptcha.forEach((btn) => {
      const formId = btn.dataset.formId;
      const form = document.getElementById(formId);
      if (!form) return;

      form.addEventListener("focusin", handleFormFocusIn);
      formsRecaptcha.push(form);

      form.addEventListener(
        "submit",
        (e) => {

          if (!window.grecaptcha) {
            e.preventDefault();
            loadRecaptchaScript();
            return;
          }

          if (btn.dataset.size !== "invisible") return;

          e.preventDefault();

          window.grecaptcha.execute();
        },
        true
      );
    });
  }
});

window.invisibleRecaptchaSubmit_newsletter_form = function () {
  const form = document.getElementById("newsletter-form");
  if (!form) return;

  form.submit();
};
